import { User, Calendar, Clock } from "lucide-react";

/**
 * Componente per mostrare i metadati autore di una sezione
 * @param {Object} props
 * @param {string} props.createdBy - Nome dell'utente che ha creato
 * @param {string} props.createdAt - Data di creazione (ISO string)
 * @param {string} props.updatedBy - Nome dell'utente che ha modificato
 * @param {string} props.updatedAt - Data ultima modifica (ISO string)
 * @param {string} props.className - Classi CSS aggiuntive
 */
export function SectionMetadata({ 
  createdBy, 
  createdByName,
  createdAt, 
  updatedBy, 
  updatedByName,
  updatedAt,
  className = ""
}) {
  // Formatta la data in italiano
  const formatDate = (isoString) => {
    if (!isoString) return "N/D";
    try {
      const date = new Date(isoString);
      return date.toLocaleDateString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    } catch {
      return isoString;
    }
  };

  // Se non ci sono metadati, non mostrare nulla
  if (!createdBy && !createdByName && !updatedBy && !updatedByName) {
    return null;
  }

  const authorName = createdByName || createdBy || "Sconosciuto";
  const modifierName = updatedByName || updatedBy;
  
  return (
    <div className={`px-1 text-[11px] text-slate-400 ${className}`}>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        {/* Creato da */}
        <div className="flex items-center gap-1">
          <User className="w-3 h-3" />
          <span>Redatto da:</span>
          <span className="font-semibold text-slate-600">{authorName}</span>
        </div>
        
        {/* Data creazione */}
        {createdAt && (
          <div className="flex items-center gap-1">
            <Calendar className="w-3 h-3" />
            <span>il</span>
            <span className="font-medium text-slate-500">{formatDate(createdAt)}</span>
          </div>
        )}
        
        {/* Ultima modifica (se diversa dalla creazione) */}
        {modifierName && updatedAt && updatedAt !== createdAt && (
          <>
            <span className="text-slate-300">|</span>
            <div className="flex items-center gap-1">
              <Clock className="w-3 h-3" />
              <span>Ultima modifica:</span>
              <span className="font-semibold text-slate-600">{modifierName}</span>
              <span>il</span>
              <span className="font-medium text-slate-500">{formatDate(updatedAt)}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

/**
 * Versione compatta per spazi ridotti
 */
export function SectionMetadataCompact({ 
  updatedByName,
  updatedAt,
  className = ""
}) {
  const formatDate = (isoString) => {
    if (!isoString) return "";
    try {
      const date = new Date(isoString);
      return date.toLocaleDateString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit"
      });
    } catch {
      return "";
    }
  };

  if (!updatedByName || !updatedAt) return null;

  return (
    <span className={`text-xs text-slate-400 ${className}`}>
      Mod. {formatDate(updatedAt)} da {updatedByName}
    </span>
  );
}

export default SectionMetadata;
